export const BATCH_PROCESSING_ROUTE_PATHS = {
  batchProcessing: '/batch-processing',
};
